import { NgModule } from "@angular/core";
import { SharedModule } from "@app/view/shared";
import { PlanningRoutingModule } from "@app/view/planning/planning-routing.module";
import { ResourceScheduleListComponent } from "./resource-schedule-list/resource-schedule-list.component";
import { SolverStatusWidgetComponent } from "@app/view/planning/solver-status-widget/solver-status-widget.component";
import { JobEditorComponent } from "./job-editor/job-editor.component";
import { ScheduleViewerComponent } from "@app/view/planning/schedule-viewer/schedule-viewer.component";
import { TicketEditDialogComponent } from "./ticket-edit-dialog/ticket-edit-dialog.component";
import { SchedulerService } from "@app/view/planning/schedule-viewer/scheduler.service";
import { TicketDrag } from "@app/view/planning/schedule-viewer/ticket-drag";
import { JobInfoDialogComponent } from "./job-info-dialog/job-info-dialog.component";
import { SolverScoreDialogComponent } from "@app/view/planning/solver-status-widget/solver-score-dialog.component";
import { UrmIntegrationModule } from "@app/integrations/urm/urm-integration.module";
import { TicketActionDialogComponent } from "./ticket-action-dialog/ticket-action-dialog.component";
import { TicketCompletionUtilityComponent } from "./ticket-completion-utility/ticket-completion-utility.component";
import { PlannerNoteEditDialogComponent } from "./planner-note-edit-dialog/planner-note-edit-dialog.component";
import { TicketFollowOnDialogComponent } from "./ticket-follow-on-dialog/ticket-follow-on-dialog.component";
import { ResourceDetailComponent } from "./resource-detail/resource-detail.component";
import { TicketDurationDialogComponent } from "./ticket-duration-dialog/ticket-duration-dialog.component";
import { LiveMapComponent } from "./live-map/live-map.component";
import { TicketDespatchDialogComponent } from "./ticket-despatch-dialog/ticket-despatch-dialog.component";
import { MeetingActionDialogComponent } from "./meeting-action-dialog/meeting-action-dialog.component";
import { MeetingEditorComponent } from "./meeting-editor/meeting-editor.component";
import { VisitTicketEditorComponent } from "./visit-ticket-editor/visit-ticket-editor.component";

@NgModule({
  imports: [
    SharedModule,
    UrmIntegrationModule,
    PlanningRoutingModule,
    ResourceScheduleListComponent,
    SolverStatusWidgetComponent,
    JobEditorComponent,
    ScheduleViewerComponent,
    TicketEditDialogComponent,
    JobInfoDialogComponent,
    SolverScoreDialogComponent,
    ResourceDetailComponent,
    SolverScoreDialogComponent,
    TicketActionDialogComponent,
    TicketCompletionUtilityComponent,
    PlannerNoteEditDialogComponent,
    TicketFollowOnDialogComponent,
    TicketDurationDialogComponent,
    LiveMapComponent,
    TicketDespatchDialogComponent,
    MeetingActionDialogComponent,
    MeetingEditorComponent,
    VisitTicketEditorComponent
  ],
  exports: [SolverStatusWidgetComponent],
  providers: [SchedulerService, TicketDrag]
})
export class PlanningModule {}
